'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';

/** Basic URL validation regex */
const URL_REGEX = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
const validateUrl = (url: string): string | null => {
  if (!url.trim()) {
    return 'URL cannot be empty';
  }

  // Add protocol if missing
  const urlWithProtocol = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
  try {
    new URL(urlWithProtocol);
    return null;
  } catch {
    return 'Please enter a valid URL';
  }
};
interface OpenUrlDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onOpen: (url: string) => void;
}
export const LoadUrlDialog = t0 => {
  const $ = _c(40);
  const {
    isOpen,
    onOpenChange,
    onOpen
  } = t0;
  const [tempUrl, setTempUrl] = useState("");
  const [inputError, setInputError] = useState("");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = value => {
      setTempUrl(value);
      const error = validateUrl(value);
      setInputError(error ?? "");
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleUrlInput = t1;
  let t2;
  if ($[1] !== onOpen || $[2] !== onOpenChange || $[3] !== tempUrl) {
    t2 = () => {
      const error_0 = validateUrl(tempUrl);
      if (error_0) {
        setInputError(error_0);
        return;
      }
      const urlWithProtocol = tempUrl.startsWith("http://") || tempUrl.startsWith("https://") ? tempUrl : `https://${tempUrl}`;
      onOpenChange(false);
      onOpen(urlWithProtocol);
      setTempUrl("");
    };
    $[1] = onOpen;
    $[2] = onOpenChange;
    $[3] = tempUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSubmit = t2;
  let t3;
  if ($[5] !== onOpenChange) {
    t3 = open => {
      if (open) {
        setTempUrl("");
        setInputError("");
      }
      onOpenChange(open);
    };
    $[5] = onOpenChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleOpenChange = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DialogHeader><DialogTitle>Dev Load URL</DialogTitle></DialogHeader>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => handleUrlInput(e.target.value);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleSubmit || $[10] !== inputError || $[11] !== tempUrl) {
    t6 = e_0 => {
      e_0.stopPropagation();
      e_0.key === "Enter" && !inputError && tempUrl.trim() && handleSubmit();
    };
    $[9] = handleSubmit;
    $[10] = inputError;
    $[11] = tempUrl;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = inputError ? "border-red-500" : "";
  let t8;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== tempUrl) {
    t8 = <Input placeholder="Enter URL (e.g., google.com or https://example.com)" value={tempUrl} onChange={t5} onKeyDown={t6} className={t7} />;
    $[13] = t6;
    $[14] = t7;
    $[15] = tempUrl;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== inputError) {
    t9 = inputError && <p className="text-sm text-red-500 mt-2">{inputError}</p>;
    $[17] = inputError;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="py-4">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== handleOpenChange) {
    t11 = <Button onClick={() => handleOpenChange(false)}>Cancel</Button>;
    $[22] = handleOpenChange;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== inputError || $[25] !== tempUrl) {
    t12 = !!inputError || !tempUrl.trim();
    $[24] = inputError;
    $[25] = tempUrl;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== handleSubmit || $[28] !== t12) {
    t13 = <Button onClick={handleSubmit} disabled={t12}>Open</Button>;
    $[27] = handleSubmit;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t11 || $[31] !== t13) {
    t14 = <DialogFooter>{t11}{t13}</DialogFooter>;
    $[30] = t11;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t10 || $[34] !== t14) {
    t15 = <DialogContent>{t4}{t10}{t14}</DialogContent>;
    $[33] = t10;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== handleOpenChange || $[37] !== isOpen || $[38] !== t15) {
    t16 = <Dialog open={isOpen} onOpenChange={handleOpenChange}>{t15}</Dialog>;
    $[36] = handleOpenChange;
    $[37] = isOpen;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};